import {
  widgetOpen,
  widgetClose,
  closeAll,
} from './c-common';

export default function () {
  const cleans = document.querySelectorAll('.js-control-clean');
  cleans.forEach((el) => {
    el.addEventListener('click', (event) => {
      const { target } = event;
      const dataInput = target.dataset.input;
      const input = document.getElementById(dataInput);
      input.value = '';
    });
  });

  window.document.addEventListener('DOMContentLoaded', () => {
    const controls = [...window.document.getElementsByClassName('js-control')];
    const containers = [...window.document.getElementsByClassName('js-control-container')];
    controls.forEach((control) => {
      const trigger = control.querySelector('.js-control-trigger');
      const container = control.querySelector('.js-control-container');
      trigger.addEventListener('click', () => {
        closeAll(containers);
        widgetOpen(container);
      });
    });
  });

  window.document.addEventListener('click', (event) => {
    const controls = [...window.document.getElementsByClassName('js-control')];
    const { target } = event;
    const closest = target.closest('.js-control');
    if (closest === null) {
      controls.forEach((control) => {
        const container = control.querySelector('.js-control-container');
        container.classList.remove('open');
      });
    }
  });

  const elementsControlBack = window.document.querySelectorAll('.js-control-back');
  elementsControlBack.forEach((el) => {
    el.addEventListener('click', (event) => {
      const { target } = event;
      const control = target.closest('.js-control');
      const controlContainer = control.querySelector('.js-control-container');
      widgetClose(controlContainer);
    });
  });
}
